import PropTypes from 'prop-types';
import classNames from 'classnames';

import styleSheet from '../scss/carouselControls.module.scss';
import ChevronLeftIcon from '../../../assets/icons/ChevronLeftIcon';
import ChevronRightIcon from '../../../assets/icons/ChevronRigthIcon';
import { useCarousel } from '../hooks/useCarousel';

const styles = styleSheet.locals || {};

/**
 * Component which displays controller of the slider
 *
 * @param {object} props option props
 * @param {object} props.elementRef reference of slider
 * @returns {Function} <CarouselControls />
 */
function CarouselControls({ elementRef }) {
    const {
        leftArrowDisable,
        rightArrowDisable,
        pageCount,
        isIndicatorActive,
        scrollByPage
    } = useCarousel(elementRef);

    return (
        <>
            <style>{styleSheet.toString()}</style>
            <div className={styles.carouselControlsHeader}>
                <ol className={styles.carouselControlsSlider}>
                    {Array.from({ length: pageCount }, (unused, index) => (
                        <li
                            key={index}
                            className={classNames(
                                styles.carouselControlsSliderIndicator,
                                {
                                    [styles.carouselControlsSliderIndicatorActive]:
                                        isIndicatorActive(index)
                                }
                            )}
                        />
                    ))}
                </ol>
                <div dir="ltr" className={styles.carouselControlsContent}>
                    <button
                        className={styles.carouselControlsButton}
                        onClick={() => scrollByPage(-1)}
                        disabled={leftArrowDisable}
                    >
                        <ChevronLeftIcon />
                    </button>
                    <button
                        className={styles.carouselControlsButton}
                        onClick={() => scrollByPage(1)}
                        disabled={rightArrowDisable}
                    >
                        <ChevronRightIcon />
                    </button>
                </div>
            </div>
        </>
    );
}

CarouselControls.propTypes = {
    elementRef: PropTypes.object.isRequired
};

export { CarouselControls };
